import { addMonths } from 'date-fns'

export const getCurrentDate = (baseDate: Date, shownMonthIndex?: number) =>
  shownMonthIndex !== undefined ? addMonths(baseDate, shownMonthIndex) : baseDate
